"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectRoles = exports.serverRoles = exports.registrationMechanisms = void 0;
exports.registrationMechanisms = ['self-gen-key', 'google-id-token', 'phone-otp'];
exports.serverRoles = ['SUPER_ADMIN', 'ADMIN', 'COORDINATOR', 'INACTIVE'];
exports.projectRoles = [
    'PROJECT_MANAGER',
    'PROJECT_COORDINATOR',
    'FINANCE_MANAGER',
    'TECH_SUPPORT',
    'EXTERNAL_COORDINATOR',
];
//# sourceMappingURL=Auth.js.map